// extracted by mini-css-extract-plugin
export default {"modal":"VideoModal_modal__IVOYF","modalContent":"VideoModal_modalContent__iMpV1"};